import { Button, Input, Modal } from "antd";
import { useState } from "react";
import SportTooltip from "../controls/sport-tooltip/sport-tooltip";

/** Проверка что устройство - телефон (проверка по ширине окна браухзера) */
export const isMobile = window.screen.availWidth <= 500;

/** Высота меню для мобильного дизайна */
export const menuSize = 96;

// Хук для управления hover состоянием
const useHover = () => {
  const [isHovered, setIsHovered] = useState(false);
  return {
    isHovered,
    hoverProps: {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    }
  };
};

// Компонент кнопки с иконкой
const IconButton = ({ title, onClick, icon, hoverIcon, alt, disabled, id }) => {
  const { isHovered, hoverProps } = useHover();
  
  return (
    <SportTooltip title={title}>
      <Button id={id} className="icon-btn" onClick={onClick} disabled={disabled} {...hoverProps}>
        <img src={isHovered && !disabled ? hoverIcon : icon} alt={alt} />
      </Button>
    </SportTooltip>
  );
};

export const CopyButton = ({ onClick, disabled }) => (
  <IconButton
    title="Копировать выбранные записи"
    onClick={onClick}
    icon="/images/copy-green.svg"
    hoverIcon="/images/copy-white.svg"
    alt="copy"
    disabled={disabled}
  />
);

export const RefreshButton = ({ onClick }) => (
  <IconButton
    title="Обновить"
    onClick={onClick}
    icon="/images/refresh.svg"
    hoverIcon="/images/refresh-white.svg"
    alt="refresh"
  />
);

export const SmartButton = ({ onClick, id }) => (
  <IconButton
    title="Смарт — автоматическая запись на набор услуг"
    onClick={onClick}
    icon="/images/smart-green.svg"
    hoverIcon="/images/smart-white.svg"
    alt="smart"
    id={id}
  />
);

export const PrintButton = ({ onClick }) => (
  <IconButton
    title="Печать"
    onClick={onClick}
    icon="/images/print-green.svg"
    hoverIcon="/images/print-white.svg"
    alt="print"
  />
);

export const ExportExcelButton = ({ onClick }) => (
  <IconButton
    title="Экспорт в Excel"
    onClick={onClick}
    icon="/images/excel.svg"
    hoverIcon="/images/excel-white.svg"
    alt="excel"
  />
);

export const HelpButton = ({ article }) => (
  <IconButton
    title="Справка"
    onClick={() => window.open(`${process.env.REACT_APP_KB_URL}article/${article}`, '_blank')}
    icon="/images/help.svg"
    hoverIcon="/images/help-white.svg"
    alt="help"
  />
);

export const ScanButton = ({ title, onScan, disabled = false, id, style }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = () => {
    setModalOpen(false);
    if (inputValue) onScan(inputValue);
  };

  return (
    <SportTooltip title={title}>
        <img
          src="/images/scan.svg"
          style={{ width: 32, marginLeft: 16, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, ...style }}
          alt="scan"
          onClick={() => !disabled && setModalOpen(true)}
          id={id ?? 'tour-item-settings-products-scanner'}
        />
        {modalOpen && (
          <Modal open={modalOpen} title="Ввод кода" onCancel={() => setModalOpen(false)} 
            footer={[<Button key="cancel" onClick={() => setModalOpen(false)}>Отмена</Button>, <Button key="ok" type="primary" onClick={handleSubmit}>OK</Button>]}
            afterOpenChange={open => {
              if (open) {
                setTimeout(() => {
                  const input = document.getElementById('scan-input');
                  if (input) {
                    input.focus();
                    input.select();
                  }
                }, 0);
              }
            }}
          >
            <Input id="scan-input" placeholder="Введите код и нажмите Enter" value={inputValue} onChange={e => setInputValue(e.target.value)} onPressEnter={handleSubmit} />
          </Modal>
        )}
    </SportTooltip>
  );
};